import React, { useMemo, useState } from 'react';

import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useAccount } from '@contexts/AccountProvider';
import useGetCustomerDetails from '@hooks/queries/useGetCustomerDetails';
import flexControls from '@messages/flexControls/flexControls';
import CardSteps from '@pages/flexControls/createCardControlContainer/cardEnums';
import CardFlexControlSteps from '@pages/flexControls/createCardControlContainer/CardFlexControlSteps';
import CustomerFlexControlsHeader from '@pages/flexControls/createCustomerFlexControl/CustomerFlexControlsHeader';
import getEnumTranslation from '@utils/getEnumTranslation';

const CreateCardControlContainer = () => {
    const [stepperStage, setStepperStage] = useState<CardSteps>(
        CardSteps.CardSelection,
    );
    const { customerId } = useParams();
    const { account } = useAccount();
    const { data, isLoading } = useGetCustomerDetails({
        customerId: +customerId,
    });

    const getDescription = () => {
        switch (stepperStage) {
            case 0:
                return getEnumTranslation('card_selection', {
                    messages: flexControls,
                });
            case 1:
                return getEnumTranslation('basic_details', {
                    messages: flexControls,
                });
            case 2:
                return getEnumTranslation('reset_period', {
                    messages: flexControls,
                });
            case 3:
                return getEnumTranslation('conditions', {
                    messages: flexControls,
                });
        }
    };

    const cachedDescription = useMemo(getDescription, [stepperStage]);

    const title = (
        <FormattedMessage
            id="CreateCardControl.title"
            defaultMessage="Add card control for ‘{customerName}’"
            values={{
                customerName: data?.customer?.printed_name,
            }}
        />
    );

    return (
        <>
            <CustomerFlexControlsHeader
                isLoading={isLoading}
                description={cachedDescription}
                title={title}
            />
            <CardFlexControlSteps
                account={account}
                customerName={data?.customer?.printed_name}
                stepperStage={stepperStage}
                setStepperStage={setStepperStage}
                customerId={parseFloat(customerId)}
            />
        </>
    );
};

export default CreateCardControlContainer;
